import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import _createForOfIteratorHelper from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScrollPane from "./ScrollPane";
import path from "path";
import actions from "../../../micro/actions.js";
import { mapState } from "vuex";
export default {
  components: {
    ScrollPane: ScrollPane
  },
  data: function data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      workTypeShow: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    workeStatus: function workeStatus(state) {
      return state.tagsView.workeStatus;
    }
  })), {}, {
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    },
    routes: function routes() {
      return this.$store.state.permission.routers;
    },
    sidebarRouters: function sidebarRouters() {
      return this.$store.getters.sidebarRouters;
    }
  }),
  watch: {
    $route: function $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible: function visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    }
  },
  mounted: function mounted() {
    this.initTags();
    this.addTags();
  },
  methods: {
    beforeClose: function beforeClose() {
      this.workTypeShow = false;
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    filterAffixTags: function filterAffixTags(routes) {
      var _this = this;
      var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var tags = [];
      routes.forEach(function (route) {
        if (route.meta && route.meta.affix) {
          var tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: _objectSpread({}, route.meta)
          });
        }
        if (route.children) {
          var tempTags = _this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [].concat(_toConsumableArray(tags), _toConsumableArray(tempTags));
          }
        }
      });
      return tags;
    },
    initTags: function initTags() {
      var affixTags = this.affixTags = this.filterAffixTags(this.routes);
      var _iterator = _createForOfIteratorHelper(affixTags),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tag = _step.value;
          // Must have tag name
          if (tag.name) {
            this.$store.dispatch("tagsView/addVisitedView", tag);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    addTags: function addTags() {
      var _this$$route = this.$route,
        name = _this$$route.name,
        path = _this$$route.path;
      var meta_info = "";
      //meta_info = this.childrenBaseUrl(this.sidebarRouters, path);
      if (path.startsWith("/fleet/management/yk-intervention-record-detail")) {
        meta_info = this.childrenBaseUrl(this.sidebarRouters, "/fleet/management/yk-intervention-record-detail");
        meta_info.meta.title = "干预明细-" + this.$route.query.name;
      } else {
        meta_info = this.childrenBaseUrl(this.sidebarRouters, path);
      }
      /**
       * 详情特制页签
       * @route /merchantManage-detail
       */
      if (path.startsWith("/merchantManage-detail")) {
        this.$route.meta.title = "商户详情 - " + this.$route.query.name;
      }
      if (path.startsWith("/placeOrder")) {
        this.$route.meta.title = "下单 - " + this.$route.query.name;
      }
      if (path.startsWith("/carInfoDetail")) {
        this.$route.meta.title = "车辆信息 - " + this.$route.query.name;
      }
      if (path.startsWith("/yk-intervention-record-detail")) {
        this.$route.meta.title = "干预明细 - " + this.$route.query.name;
      }
      if (path.startsWith("/yk-recharge-details")) {
        this.$route.meta.title = "充值明细 - " + this.$route.query.name;
      }
      if (path.startsWith("/yk-bill-details")) {
        this.$route.meta.title = "账单明细 - " + this.$route.query.name;
      }
      if (path.startsWith("/work-order-detail")) {
        this.$route.meta.title = "工单详情 - " + this.$route.query.name;
      }
      if (path.startsWith("/terminal/TerminalDetail")) {
        this.$route.meta.title = "终端详情 - " + this.$route.query.name;
      }
      if (path.startsWith("/poi-info-operation")) {
        this.$route.meta.title = "POI信息 - " + this.$route.query.name;
      }
      if (path.startsWith("/faw-second-floor-web/groupchat-management/circleGroupDetail")) {
        var title = this.$route.query.name ? meta_info.meta.title : meta_info.meta.title;
        this.$route.meta.title = title;
        this.$store.dispatch("tagsView/addView", this.$route);
        return;
      }
      if (meta_info) {
        this.$route.meta.title = meta_info.meta.title;
        this.$route.meta.noCache = meta_info.meta.noCache;
      }
      if (name || meta_info) {
        // tab view 显示的另外一种方式
        // this.$store.dispatch("tagsView/name_meta_change", name_meta);
        this.$store.dispatch("tagsView/addView", this.$route);
      }
      return false;
    },
    childrenBaseUrl: function childrenBaseUrl(list, url) {
      var _this2 = this;
      var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      list.forEach(function (item) {
        if (item.path === url) {
          meta = item;
        } else {
          if (item.children && item.children.length) {
            meta = _this2.childrenBaseUrl(item.children, url, meta);
          }
        }
      });
      return meta;
    },
    moveToCurrentTag: function moveToCurrentTag() {
      var _this3 = this;
      var tags = this.$refs.tag;
      this.$nextTick(function () {
        var _iterator2 = _createForOfIteratorHelper(tags),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tag = _step2.value;
            if (tag.to.path === _this3.$route.path) {
              _this3.$refs.scrollPane.moveToTarget(tag);
              // when query is different then update
              if (tag.to.fullPath !== _this3.$route.fullPath) {
                _this3.$store.dispatch("tagsView/updateVisitedView", _this3.$route);
              }
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
    },
    refreshSelectedTag: function refreshSelectedTag(view) {
      var _this4 = this;
      this.$store.dispatch("tagsView/delCachedView", view).then(function () {
        var fullPath = view.fullPath;
        _this4.$nextTick(function () {
          _this4.$router.replace({
            path: "/redirect" + fullPath
          });
        });
      });
    },
    closeSelectedTag: function closeSelectedTag(view) {
      var _this5 = this;
      var cacheFlag = view.meta.noCache;
      if (!cacheFlag) {
        actions.setGlobalState({
          dealerUrl: view.fullPath,
          type: 1
        });
        setTimeout(function () {
          actions.setGlobalState({
            dealerUrl: "",
            type: 0
          });
        }, 500);
      }
      if (this.workeStatus !== "outLine" && (view.path.startsWith("/ykRealTimeRiskMonitoringConsole") || view.path.startsWith("/fleet/management/yk-real-time-risk-monitoring-console"))) {
        this.workTypeShow = true;
      } else {
        this.$store.dispatch("tagsView/delView", view).then(function (_ref) {
          var visitedViews = _ref.visitedViews;
          if (_this5.isActive(view)) {
            _this5.toLastView(visitedViews, view);
          }
        });
      }
    },
    closeOthersTags: function closeOthersTags(view) {
      var _this6 = this;
      var cacheFlag = view.meta.noCache;
      if (!cacheFlag) {
        actions.setGlobalState({
          dealerUrl: this.selectedTag.fullPath,
          type: 2
        });
        setTimeout(function () {
          actions.setGlobalState({
            dealerUrl: "",
            type: 0
          });
        }, 500);
      }
      this.$router.push(this.selectedTag);
      this.$store.dispatch("tagsView/delOthersViews", this.selectedTag).then(function () {
        _this6.moveToCurrentTag();
      });
    },
    closeAllTags: function closeAllTags(view) {
      var _this7 = this;
      var cacheFlag = view.meta.noCache;
      if (!cacheFlag) {
        actions.setGlobalState({
          type: 3
        });
        setTimeout(function () {
          actions.setGlobalState({
            type: 0
          });
        }, 500);
      }
      this.$store.dispatch("tagsView/delAllViews").then(function (_ref2) {
        var visitedViews = _ref2.visitedViews;
        if (_this7.affixTags.some(function (tag) {
          return tag.path === view.path;
        })) {
          return;
        }
        _this7.toLastView(visitedViews, view);
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "Dashboard") {
          // to reload home page
          this.$router.replace({
            path: "/redirect" + view.fullPath
          });
        } else {
          this.$router.push("/");
        }
      }
    },
    openMenu: function openMenu(tag, e) {
      var menuMinWidth = 105;
      var offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      var offsetWidth = this.$el.offsetWidth; // container width
      var maxLeft = offsetWidth - menuMinWidth; // left boundary
      var left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }
      this.top = e.clientY;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu: function closeMenu() {
      this.visible = false;
    }
  }
};